import AffiliateSignup from './affiliate_signup'
import IncomingEmails from './incoming_emails'
import PaymentMethods from './payment_methods'
import Page from '@admin/components/page'
import Subscription from './subscription'
import SignupPage from './signup_page'
import Activities from './activities'
import Properties from './properties'
import Templates from './templates'
import Referrals from './referrals'
import Affiliate from './affiliate'
import Sessions from './sessions'
import Profiles from './profiles'
import Programs from './programs'
import Overview from './overview'
import Invoices from './invoices'
import Senders from './senders'
import Payouts from './payouts'
import Themes from './themes'
import Roles from './roles'
import Users from './users'
import Usage from './usage'
import React from 'react'
import Tags from './tags'
import Apps from './apps'

const mapPropsToPage = (props, context, resources, page) => ({
  title: resources.team.title,
  manager: {
    path: '/admin/team',
    items: [
      {
        label: 't(Overview)',
        panel: <Overview team={ resources.team } />
      },
      {
        label: 't(Activities)',
        path: '/activities',
        access: { rights: { $oneOf: ['team:manage_configuration']} },
        panel: <Activities />
      },
      {
        label: 't(Affiliate Program)',
        access: { 'features.affiliate': { $eq: true } },
        ...context.admin.team.is_affiliate ? {
          children: [
            {
              label: 't(Overview)',
              path: '/affiliate',
              panel: <Affiliate />
            },
            {
              label: 't(Payouts)',
              path: '/payouts',
              panel: <Payouts/>
            },
            {
              label: 't(Referrals)',
              path: '/referrals',
              panel: <Referrals />
            // },
            // {
            //   label: 't(Signup Page)',
            //   path: '/signup_page',
            //   panel: <SignupPage />
            }
          ]
        } : {
          path: '/affiliate',
          panel: <AffiliateSignup />
        }
      },
      {
        label: 't(Apps)',
        path: '/apps',
        access: { rights: { $oneOf: ['team:manage_configuration']} },
        panel: <Apps />
      },
      {
        label: 't(Billing)',
        children: [
          {
            label: 't(Subscription)',
            path: '/subscription',
            show: props.subscription !== null,
            panel: <Subscription />
          },
          {
            label: 't(Payment Methods)',
            path: '/payment_methods',
            show: props.subscription === null,
            panel: <PaymentMethods />
          },
          {
            label: 't(Payment History)',
            path: '/invoices',
            panel: <Invoices />
          }
        ]
      },
      {
        label: 't(Incoming Emails)',
        path: '/incoming_emails',
        access: { rights: { $oneOf: ['team:manage_configuration']} },
        panel: <IncomingEmails />
      },
      {
        label: 't(Profiles)',
        path: '/profiles',
        show: !context.admin.team.has_programs,
        access: { rights: { $oneOf: ['team:view_profiles','team:manage_profiles']} },
        panel: <Profiles />
      },
      {
        label: 't(Programs)',
        path: '/programs',
        access: { rights: { $oneOf: ['team:view_programs','team:manage_programs']} },
        show: context.admin.team.has_programs,
        panel: <Programs />
      },
      {
        label: 't(Properties)',
        path: '/properties',
        show: !context.admin.team.has_programs,
        access: { rights: { $oneOf: ['team:view_properties','team:manage_properties']} },
        panel: <Properties />
      },
      {
        label: 't(Roles)',
        path: '/roles',
        access: { rights: { $oneOf: ['team:view_roles','team:manage_roles'] } },
        panel: <Roles />
      },
      {
        label: 't(Senders)',
        path: '/senders',
        show: !context.admin.team.has_programs,
        access: { rights: { $oneOf: ['team:view_senders','team:manage_senders']} },
        panel: <Senders />
      },
      {
        label: 't(Sessions)',
        path: '/sessions',
        access: { rights: { $oneOf: ['team:manage_configuration']} },
        panel: <Sessions />
      },
      {
        label: 't(Tags)',
        path: '/tags',
        show: !context.admin.team.has_programs,
        access: { rights: { $oneOf: ['team:manage_configuration']} },
        panel: <Tags />
      },
      {
        label: 't(Templates)',
        path: '/templates',
        show: !context.admin.team.has_programs,
        access: { rights: { $oneOf: ['team:view_templates','team:manage_templates']} },
        panel: <Templates />
      },
      {
        label: 't(Themes)',
        path: '/themes',
        show: !context.admin.team.has_programs,
        access: { rights: { $oneOf: ['team:view_templates','team:manage_templates']} },
        panel: <Themes />
      },
      {
        label: 't(Users)',
        path: '/users',
        access: { rights: { $oneOf: ['team:view_users','team:manage_users'] } },
        panel: <Users />
      }
    ]
  }
})

const mapResourcesToPage = (props, context) => ({
  subscription: '/api/admin/team/subscription',
  team: '/api/admin/team/settings'
})

export default Page(mapResourcesToPage, mapPropsToPage)
